import React, { useEffect, useState } from "react";
import { hdfcPayment } from "../../store/slices/Payment/checkoutSlice";
import { useDispatch, useSelector } from "react-redux";
import HdfcRedirect from "../HdfcRedirect";
import { useNavigate, useParams } from "react-router-dom";
import Style from "./Payment.module.scss";
import { Button, Modal } from "react-bootstrap";

const Payment = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { plan_id, clientID, projectID } = useParams();

  const [responce, setResponce] = useState({});
  const { hdfc_payment } = useSelector((state) => state.payment);

  const { REACT_APP_APIURL, REACT_APP_APIURL_LIVE, REACT_APP_DEV_ENV } =
    process.env;

  const MAIN_URL =
    REACT_APP_DEV_ENV == "PRODUCTION"
      ? REACT_APP_APIURL_LIVE
      : REACT_APP_APIURL;

  useEffect(() => {
    const obj = {
      redirect_url: `${MAIN_URL}payment/verify-order`,
      cancel_url: `${MAIN_URL}payment/verify-order`,
      plan_id: plan_id,
    };

    if (clientID !== undefined) {
      obj.client_id = clientID;
    }

    if (projectID !== undefined) {
      obj.project_id = projectID;
    }

    dispatch(hdfcPayment(obj))
      .unwrap()
      .then((res) => {
        setResponce(res.data.result);
      });
  }, []);
  const handleNavigate = () => navigate(-1);

  if (responce?.order_id) {
    return <HdfcRedirect />;
  }
  if (hdfc_payment?.status === false) {
    return (
      <>
        <Modal
          show={true}
          onHide={false}
          backdrop={true}
          centered={true}
          className={`${Style.CommonModal}`}
        >
          <Modal.Header>
            <Modal.Title><h4>Payment Warning!</h4></Modal.Title>
          </Modal.Header>
          <Modal.Body>{hdfc_payment?.error}</Modal.Body>
          <Modal.Footer>
          <Button variant="primary"  onClick={() => handleNavigate()}>Go Back</Button>
          </Modal.Footer>
        </Modal>
        
      </>
    );
  }

  // return <DashboardLoader />;
};

export default Payment;